import { getAuth } from "firebase/auth";

// Function checks if user is signed in and returns their Firebase ID token
export async function getFirebaseIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) return null;
  
  return await user.getIdToken(/* forceRefresh: */ false);
}
